<template>
  <!-- TODO: datepicker nema rules, treba dorobit required kontrolu -->
  <div v-click-outside="clickOutside" v-if="l_visible">
    <div ref="dtpTxt">
      <v-text-field
        :rules="getRules"
        ref="control"
        class="calendar-input dynamic-input-control"
        outlined
        :label="getLabel"
        :append-icon="getDisabled ? '' : (tooltipAppendIcon.length == 0 ? icon : '')"
        :loading="isLoading"
        :value="strVal"
        @focus="onFocus"
        @click="onFocus"
        @change="onTextChange"
        @keydown="keydown"
        @mousedown="handleMouseDown"
        @input="v => (dirtyText = v)"
        :dense="dense"
        :placeholder="placeholder"
        :class="{
          validated: displayValidated && !hasError && !errorMessages,
          required: l_required,
          naked,
          readonly: readonly || isDisabled || isLoading,
          'hide-error-icon': hideErrorIcon,
        }"
        :disabled="getDisabled"
        :error-messages="errorMessages"
      >
        <template slot="append" v-if="!getDisabled && (tooltipAppendIcon.length > 0)">
          <v-tooltip top max-width="350">
            <template v-slot:activator="{ on }">
              <v-icon class="btn-help ml-2 mt-1 text-body-2" style="cursor: pointer" v-on="on">
                {{ icon }}
              </v-icon>
            </template>
            <span>{{ tooltipAppendIcon }}</span>
          </v-tooltip>
        </template>
        <template slot="append" v-if="!!getTooltip">
          <div class="v-input__icon v-input__icon--append" v-if="!getDisabled  && (tooltipAppendIcon.length == 0)">
            <v-icon>{{ icon }}</v-icon>
          </div>
          <v-tooltip bottom max-width="350">
            <template v-slot:activator="{ on }">
              <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
                >mdi-help-circle</v-icon
              >
            </template>
            <span> {{ getTooltip }} </span>
          </v-tooltip>
        </template>
      </v-text-field>
    </div>

    <v-slide-x-transition>
      <div ref="dtp" class="date-picker-box-wrapper" :style="{ top: overflow + 'px' }">
        <v-date-picker
          v-show="showMenu"
          class="pa-0 date-picker-box"
          :data-id="dataId"
          :type="type"
          no-title
          first-day-of-week="1"
          locale="sk-sk"
          :value="datePickerValue"
          :min="getMin"
          :max="getMax"
          @input="onInput"
          @change="emitChange"
          :range="range"
          :readonly="disabled || isDisabled || readonly || isLoading"
        >
          <v-spacer></v-spacer>
          <div class="datepicker-buttons">
            <v-btn v-if="!this.range" class="left" text @click="setToday"> Dnes </v-btn>
            <v-btn class="right btn-clear-date" text @click="deleteDate(true)"> Vymazať </v-btn>
          </div>
        </v-date-picker>
      </div>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';

export default {
  mixins: [dynamicControlMixin],
  props: {
    value: [Date, String, Array, Object, Number],
    type: String,
    range: Boolean,
    naked: Boolean,
    dense: Boolean,
    noIcon: Boolean,
    appendIcon: {
      type: String,
      default: '',
    },
    tooltipAppendIcon: {
      type: String,
      default: '',
    },
    textOnly: Boolean,
    placeholder: String,
    hideErrorIcon: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
    lastDayInMonth: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      strVal: null,
      menu: false,
      position: null,
      wh: window.innerHeight,
      overflow: 0,
      dirtyText: null,
      isFocused: false,
      datePickerValue: null,
      oldVal: null,
    };
  },
  computed: {
    icon() {
      return this.noIcon ? '' : this.appendIcon.length > 0 ? this.appendIcon : 'calendar_today';
    },
    showMenu() {
      if (this.textOnly) return false;

      return this.menu;
    },
    template() {
      return this.range ? '__/__/____ - __/__/____' : '__/__/____';
    },
    getDisabled() {
      return this.disabled || this.readonly || this.isDisabled || this.isLoading;
    },
    getMin() {
      return this.min ?? this.l_minValue;
    },
    getMax() {
      return this.max ?? this.l_maxValue;
    }
  },
  watch: {
    value(val) {
      if (!val) this.deleteDate(true);
      else this.parseDate(val, true);
      if (!this.range) {
        //ZATIAL saveValue len pre date, ktory nie je range, lebo tam neviem ako do cache ukadat tu hodnotu
        this.datePickerValue = val;
        this.saveValue(this.strVal?.replace(/-/g, ''));
      }
    },
    strVal(newVal, oldVal) {
      //pridana stara verzia strVal, ktora sa pouziva na vyhodnotenie ci bola strVal predtym null kvoli premazaniu strVal a naslednemu ulozeniu do db
      this.oldVal = oldVal;
    },
  },
  methods: {
    onInput(val) {
      this.datePickerValue = val;
      this.setDirty(true);
      this.update(val);
      console.log('onInput');
    },
    update(newVal) {
      this.$emit('input', this.datePickerValue);

      if (this.range) {
        this.datePickerValue = newVal;

        if (newVal && newVal.length > 0) {
          let d1 = this.formatDate(newVal[0]);
          let d2 = this.formatDate(newVal[1]);

          if (d1 && d2 && Date.parse(newVal[0]) > Date.parse(newVal[1])) {
            d1 = this.formatDate(newVal[1]);
            d2 = this.formatDate(newVal[0]);
            this.datePickerValue = [newVal[1], newVal[0]];
          }

          this.strVal = this.template.replaceAt(0, d1);

          if (d2) {
            this.strVal = this.strVal.replaceAt(13, d2);
          }
        } else this.strVal = this.template;
      }

      if (!this.range) {
        this.$emit('inputChanged', newVal);
        this.strVal = this.formatDate(newVal);
        //aby sa stihla formatedDate hodnota dostat do text-boxu, inak sa pri save vyhodnotilo, ze je nevalidny input ak pred zadanim hodnoty bol prazdny
        this.datePickerValue = newVal;
        this.$nextTick(() => this.saveValue(newVal?.replace(/-/g, '')));
        this.closeDtp();
        return;
      }
      if (typeof newVal !== 'string' && newVal.length == 2) {
        this.closeDtp();
      }
    },
    deleteDate(save = false) {
      this.strVal = null;
      this.datePickerValue = null;
      this.$emit('input', null);
      if (save) this.saveValue(null);
      this.closeDtp();
    },
    setToday() {
      this.setDirty(true);
      this.update(new Date().toString().toDatePickerDate());
    },
    setValue(val) {
      this.parseDate(val);

      return this.saveValue(this.datePickerValue?.replace(/-/g, ''), true);
    },
    parseDate(val, fromWatch) {
      if (val) {
        if (typeof val === 'number') {
          val = val.toString();
        }
        if (typeof val === 'string') {
          //ak pride yyyyMMdd skus ho prerobit na yyyy-MM-dd
          if (val.length === 8) {
            val = `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(6, 8)}`;
          }

          let d = Date.parse(val);

          if (!d || isNaN(d)) {
            this.datePickerValue = null;
            return;
          }
          this.datePickerValue = val;
          this.strVal = this.formatDate(val.toDatePickerDate());
        }
        if (typeof val.getMonth === 'function') {
          this.strVal = this.formatDate(val.toDatePickerDate());
        }
        this.$emit('input', this.datePickerValue);
      } else {
        this.deleteDate();
      }
    },
    open(el) {
      this.menu = !(this.isDisabled || this.readonly);

      var txtTop = this.$refs.dtpTxt.getBoundingClientRect().top;
      var txtHeigth = this.$refs.dtpTxt.offsetHeight;
      var dtpHeight = 344; //this.$refs.dtp.offsetHeight; //nakolko dtp je absolute, neviem ziskat hodnotu, dava mi 0, tak musi byt natvrdo

      this.overflow = this.wh - (txtTop + txtHeigth + dtpHeight);
      const up = -440;
      this.overflow = this.overflow >= 0 ? 0 : up; //this.overflow;
    },
    closeDtp() {
      if (this.menu) {
        this.$emit('input', this.datePickerValue);
        this.menu = false;
      }
    },
    onResize() {
      this.wh = window.innerHeight;
    },
    readData(config) {
      if (config.controlValue) {
        this.parseDate(config.controlValue);
      } else {
        this.deleteDate();
      }
    },
    dateRule(v) {
      function checkDate(dateString) {
        const [day, month, year] = dateString.split('/');
        const d = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        if (
          parseInt(day) !== d.getDate() ||
          parseInt(month) !== d.getMonth() + 1 ||
          parseInt(year) !== d.getFullYear()
        )
          return false;

        return true;
      }

      //if (this.isFocused) return true;
      if (!v) return true;
      let re = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
      let reMsg = 'Zadajte dátum dd/mm/yyyy';
      if (this.range) {
        re = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}( - ([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4})$/;
        reMsg = 'Zadajte dátum dd/mm/yyyy - dd/mm/yyyy';
      }

      if (!re.test(v)) return reMsg;

      if (this.range) {
        const [d1, d2] = v.split(' - ');
        if (!checkDate(d1) || !checkDate(d2)) return 'Zadaný dátum nie je valídny';
      } else if (!checkDate(v)) return 'Zadaný dátum nie je valídny';

      return true;
    },
    onTextChange(v) {
      this.$emit('change');
      // ak je hodnota v rovnaka template (v = __/__/____) a oldVal hodnota nebola null tak sa v nastavy na null a ulozi do db, kontrola oldVal je kvoli vyberu z kalendara.
      if (v === this.template && this.oldVal != null) {
        v = null;
        this.strVal = null;
        this.$refs.control.lazyValue = null;
      }
      if (this.dateRule(v) === true) {
        this.setDirty(true);
        if (this.range) {
          const [d1, d2] = v.split(' - ');
          const [day1, month1, year1] = d1.split('/');
          const [day2, month2, year2] = d2.split('/');
          if (day1 && month1 && year1 && day2 && month2 && year2)
            this.update([`${year1}-${month1}-${day1}`, `${year2}-${month2}-${day2}`]);
          else this.deleteDate(true);
        } else {
          let [day, month, year] = '';
          if (v) {
            [day, month, year] = v?.split('/');
          }
          if (this.getMin != null) {
            if (this.checkMinDate(new Date(year, month - 1, day))) return;
          }
          if (this.getMax != null) {
            if (this.checkMaxDate(new Date(year, month - 1, day))) return;
          }
          if (day && month && year) this.update(`${year}-${month}-${day}`);
          else this.deleteDate(true);
        }
      } else {
        this.datePickerValue = null;
      }
    },
    emitChange() {
      this.$emit('change');
    },
    loadedAll() {
      if (this.getMin != null) {
        let [day, month, year] = this.strVal?.split('/');
        this.checkMinDate(new Date(year, month - 1, day));
      }
      if (this.getMax != null) {
        let [day, month, year] = this.strVal?.split('/');
        this.checkMaxDate(new Date(year, month - 1, day));
      }
    },
    checkMinDate(date) {
      let valDate = date;
      let minDate = new Date(this.getMin);
      valDate.setHours(0, 0, 0, 0);
      minDate.setHours(0, 0, 0, 0);
      if (valDate < minDate) {
        if (this.lastDayInMonth) {
          minDate = new Date(minDate.getFullYear(), minDate.getMonth() + 1, 0);
        }
        let year = minDate.getFullYear();
        let month = minDate.getMonth() + 1;
        let day = minDate.getDate();
        if (month.toString().length < 2) month = '0' + month;
        if (day.toString().length < 2) day = '0' + day;
        if (day && month && year) {
          this.setDirty(true);
          this.update(`${year}-${month}-${day}`);
        }
        return true;
      }
      return false;
    },
    checkMaxDate(date) {
      let valDate = date;
      let maxDate = new Date(this.getMax);
      valDate.setHours(0, 0, 0, 0);
      maxDate.setHours(0, 0, 0, 0);
      if (valDate > maxDate) {
        if (this.lastDayInMonth) {
          maxDate = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 0);
        }
        let year = maxDate.getFullYear();
        let month = maxDate.getMonth() + 1;
        let day = maxDate.getDate();
        if (month.toString().length < 2) month = '0' + month;
        if (day.toString().length < 2) day = '0' + day;
        if (day && month && year) {
          this.setDirty(true);
          this.update(`${year}-${month}-${day}`);
        }
        return true;
      }
      return false;
    },
    keydown(e) {
      const text = this.strVal ?? '';
      const input = this.$refs.control.$refs.input;
      const cursorStart = input.selectionStart;
      const cursorEnd = input.selectionEnd;
      const maxLength = this.range ? 23 : 10;

      //arrow left
      if (e.keyCode === 37) {
        if (cursorStart === 13) {
          e.preventDefault();
          this.setCursor(10);
        }
        return;
      }
      //arrow right
      if (e.keyCode === 39) {
        if (cursorStart === 10) {
          e.preventDefault();
          this.setCursor(13);
        }
        return;
      }

      //handle backspace
      if (e.keyCode === 8) {
        if (cursorStart !== cursorEnd) {
          const replacement = this.template.substr(cursorStart, cursorEnd);
          this.strVal = this.strVal.replaceAt(cursorStart, replacement);
          this.setCursor(cursorStart);
          e.preventDefault();
          return;
        }

        if (cursorStart > 0) {
          if (cursorStart === 3 || cursorStart === 6 || cursorStart === 16 || cursorStart === 19) {
            this.strVal = this.strVal.replaceAt(cursorStart - 1, '/');
          } else if (cursorStart === 11 || cursorStart === 12 || cursorStart === 13) {
            this.setCursor(10);
            e.preventDefault();
            return;
          } else this.strVal = this.strVal.replaceAt(cursorStart - 1, '_');

          this.setCursor(cursorStart - 1);
          e.preventDefault();
          return;
        }
      }

      //povolene su len znaky backspace, arrow left/right, cisla
      if (!/^\d+$/.test(e.key)) {
        e.preventDefault();
        return;
      }

      if (text.length + 1 > maxLength && cursorStart === text.length) {
        e.preventDefault();
        return;
      }

      if (this.range && (cursorStart === 10 || cursorStart === 11 || cursorStart === 12)) {
        this.strVal = this.strVal.replaceAt(13, e.key);
        this.setCursor(14);
        e.preventDefault();
        return;
      }

      if (cursorStart === 2 || cursorStart === 5 || cursorStart === 15 || cursorStart === 18) {
        if (cursorStart === text.length) {
          this.strVal = `${text}/${e.key}`;
        } else if (cursorStart === text.length - 1) {
          this.strVal = this.strVal.substr(0, cursorStart) + '/' + e.key;
        } else {
          this.strVal = this.strVal.replaceAt(cursorStart + 1, e.key);
          this.$nextTick().then(() => {
            input.selectionStart = cursorStart + 2;
            input.selectionEnd = cursorStart + 2;
          });
        }

        e.preventDefault();
        return;
      }

      if (cursorStart < text.length) {
        this.strVal = this.strVal.replaceAt(cursorStart, e.key);

        this.$nextTick().then(() => {
          input.selectionStart = cursorStart + 1;
          input.selectionEnd = cursorStart + 1;
        });
        e.preventDefault();
        return;
      }
    },
    setCursor(pos) {
      const input = this.$refs.control.$refs.input;
      this.$nextTick().then(() => {
        input.selectionStart = pos ?? 0;
        input.selectionEnd = pos ?? 0;
      });
    },
    onFocus() {
      this.isFocused = true;
      this.open();

      if (!this.strVal) {
        this.strVal = this.template;
        this.setCursor();
      }

      if (this.strVal === this.template) {
        this.setCursor();
      }
      const input = this.$refs.control.$refs.input;
      const cursorStart = input.selectionStart;
      if (cursorStart === 11 || cursorStart === 11) {
        this.setCursor(13);
      }
    },
    formatDate(val) {
      //val je bud string alebo pole stringov
      if (!val) return null;

      if (typeof val === 'string') {
        return `${new Intl.DateTimeFormat('en-GB').format(Date.parse(val))}`;
      } else {
        let str = '';
        val.forEach(e => {
          str += `${new Intl.DateTimeFormat('en-GB').format(Date.parse(e))} - `;
        });
        str = str.slice(0, -3);

        return str;
      }
    },
    createDate(val) {
      let splittedDate = val.split('/');
      return new Date([splittedDate[2], splittedDate[1], splittedDate[0]].join('/'));
    },
    clickOutside() {
      this.isFocused = false;
      this.closeDtp();
      if (this.strVal === this.template) {
        this.strVal = null;
      }
    },
  },
  created() {
    if (!this.dataId && this.dynamic) {
      console.error('Datepicker nema zadane data-id !');
    }

    this.parseDate(this.value);

    this.addRule(v => this.dateRule(v));
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>
<style lang="sass"></style>
